// An eagle, modelled facing +X: a dark brown body, broad outstretched wings, a
// white head and a hooked golden beak. Ported 1:1 from age-of-mcp's classic
// eagle.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#4a3422",
      position: [0, 0.03, 0], scale: [1.6, 1, 0.9] },                // body
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#efe9dc",
      position: [0.07, 0.05, 0] },                                   // white head
    { geometry: new THREE.ConeGeometry(0.012, 0.03, 4), color: "#e0a020",
      position: [0.1, 0.046, 0], rotation: [0, 0, -1.1] },           // hooked beak
    { geometry: new THREE.ConeGeometry(0.03, 0.17, 3), color: "#3e2c1c",
      position: [-0.01, 0.03, 0.095], rotation: [Math.PI / 2, 0, 0], scale: [1, 1, 0.25] },
    { geometry: new THREE.ConeGeometry(0.03, 0.17, 3), color: "#3e2c1c",
      position: [-0.01, 0.03, -0.095], rotation: [-Math.PI / 2, 0, 0], scale: [1, 1, 0.25] },
    { geometry: new THREE.ConeGeometry(0.02, 0.06, 4), color: "#efe9dc",
      position: [-0.075, 0.03, 0], rotation: [0, 0, Math.PI / 2], scale: [1, 1, 0.4] }, // tail
  ];
}

export const eagle = defineModel({
  id: "eagle",
  batchId: "standard",
  name: "Eagle",
  tags: ["creature","eagle","low-poly","age-of-mcp","classic"],
  summary: "Low-poly eagle.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.14,
  parts: () => partsFor(),
  animations: [],
});
